import React, { Component } from 'react';
import ApiClient from '../../api/alms-api';
import Translator from '../../core/i18n';
import { Log, Level, Logger, Display } from 'ng2-logger';
import CLessonPageHeader from './header/main';
import CLessonPageTabMenu from './menu-tab/main';
import { ILessonPage, IState } from '../../models/components/lesson-upcoming-activity';

const T = Translator.create();
const _logger = Log.create('mainManu.tsx');
const token: any = localStorage.getItem('access_token');

export class LessonPage extends React.Component<any> {

    public courseNavigationn: HTMLDivElement | null = null;

    constructor(props: any) {
        super(props);
    }

    public render() {
        return (
            <div>
                <CLessonPageHeader />
                {
                    <div style={{position:'relative',top:'66px'}}>
                        <div className="lesson-tabs studen-tabs" style={{backgroundColor:'#eeede9'}}>
                            <CLessonPageTabMenu />
                        </div>
                    </div>

                }
            </div>
        );
    }
}
